import { Component, OnInit, OnDestroy, HostBinding, Input, Output, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { HistoricContextService } from '../historic-context.service';
import { POI_TYPES } from '../layers/constants';

@Component({
  selector: 'app-historic-legend',
  templateUrl: './historic-legend.component.html',
  styleUrls: ['./historic-legend.component.scss']
})
export class HistoricLegendComponent implements OnInit, OnDestroy {

  @HostBinding('class.closed') hideLegend = false;
  subscription: Subscription;
  districtLevel = true;
  filters = null;
  typeLayers = POI_TYPES;

  @Input() variable: any;
  // @Output() type: any;
  @Output() type = new EventEmitter<any>();


  constructor(
    private historicContextService: HistoricContextService
  ) {}

  ngOnInit() {
    this.subscription = this.historicContextService.mode$.subscribe((mode) => {
      this.hideLegend = false;
    });
  }

  toggleLegend() {
    this.hideLegend = !this.hideLegend;
  }

  onCheckboxChange(value, id) {
    this.type.emit({id, value});
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/historic/historic-legend/historic-legend.component.ts